/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_Storage_ExceededInputs */

const es_components_file_tree_storage_exceeded = /** @type {(inputs: Components_File_Tree_Storage_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límite de almacenamiento excedido`)
};

const en_components_file_tree_storage_exceeded = /** @type {(inputs: Components_File_Tree_Storage_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage limit exceeded`)
};

/**
* | output |
* | --- |
* | "Storage limit exceeded" |
*
* @param {Components_File_Tree_Storage_ExceededInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_storage_exceeded = /** @type {((inputs?: Components_File_Tree_Storage_ExceededInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Storage_ExceededInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_storage_exceeded(inputs)
	return en_components_file_tree_storage_exceeded(inputs)
});
export { components_file_tree_storage_exceeded as "components.file_tree.storage_exceeded" }